import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/firestore'
import axios from 'axios'

const requests = new Map()
async function read (body) {
  const account = firebase.auth().currentUser
  if (!account) throw new Error('กรุณาเข้าสู่ระบบใหม่')
  const key = account.uid + JSON.stringify(body)
  for (const [id, entry] of requests) if (entry.settled && Date.now() - entry.time >= 5000) requests.delete(id)
  const cached = requests.get(key)
  if (cached && Date.now() - cached.time < 5000) return cached.promise
  const promise = account.getIdToken().then(token => axios.post('https://api.xxmac.win/sale-access/read', body, {
    headers: { Authorization: `Bearer ${token}` }, timeout: ['dashboard', 'register'].includes(body.kind) ? 30000 : 120000
  })).then(result => {
    const current = firebase.auth().currentUser
    if (!current || current.uid !== account.uid) throw new Error('กรุณาเข้าสู่ระบบใหม่')
    return result.data
  })
  const entry = { time: Date.now(), promise, settled: false }
  requests.set(key, entry)
  while (requests.size > 32) requests.delete(requests.keys().next().value)
  try {
    const result = await promise
    entry.time = Date.now(); entry.settled = true
    return result
  } catch (error) { if (requests.get(key) === entry) requests.delete(key); throw error }
}
export const readSaleReport = (kind, start, end) => read({ kind, start, end })
export const readSaleContext = () => read({ kind: 'context' })
const denied = () => Promise.reject(new Error('บัญชีการตลาดมีสิทธิ์อ่านรายงานเท่านั้น'))
const snapshot = (value, key = null) => ({
  key, val: () => value, exists: () => value !== null && value !== undefined,
  forEach: callback => {
    for (const [id, child] of Object.entries(value || {})) if (callback(snapshot(child, id)) === true) break
  }
})
class UserQuery {
  constructor (path, filters = [], order = null, limit = null) { this.path = path; this.filters = filters; this.order = order; this.limitValue = limit; this.cancelled = false }
  child (key) { return database().ref(`${this.path}/${key}`) }
  orderByChild (field) { return new UserQuery(this.path, this.filters, field, this.limitValue) }
  equalTo (value) { return new UserQuery(this.path, [...this.filters, { field: this.order, op: '==', value }], this.order, this.limitValue) }
  startAt (value) { return new UserQuery(this.path, [...this.filters, { field: this.order, op: '>=', value }], this.order, this.limitValue) }
  endAt (value) { return new UserQuery(this.path, [...this.filters, { field: this.order, op: '<=', value }], this.order, this.limitValue) }
  limitToFirst (value) { return new UserQuery(this.path, this.filters, this.order, { direction: 'first', value }) }
  limitToLast (value) { return new UserQuery(this.path, this.filters, this.order, { direction: 'last', value }) }
  async once (event, callback) {
    const result = await read({ kind: 'database', path: this.path, filters: this.filters, order: this.order, limit: this.limitValue })
    const resultSnapshot = snapshot(result.value, this.path.split('/').pop())
    if (callback) await callback(resultSnapshot)
    return resultSnapshot
  }
  on (event, callback, errorCallback) {
    this.cancelled = false
    this.once(event).then(value => { if (!this.cancelled) callback(value) }).catch(error => { if (errorCallback) errorCallback(error) })
    return callback
  }
  off () { this.cancelled = true }
  set () { return denied() }
  update () { return denied() }
  remove () { return denied() }
  transaction () { return denied() }
}
function database () {
  const actual = firebase.database()
  return { ref: (path = '') => {
    const normalized = path.replace(/^\/+|\/+$/g, '')
    if (!normalized || normalized === 'users' || normalized.startsWith('users/')) return new UserQuery(normalized)
    return actual.ref(normalized.replace(/^employee(?=\/|$)/, 'staff_directory'))
  } }
}
Object.assign(database, firebase.database)
class ReportQuery {
  constructor (collection, filters = [], order = null, limit = null, id = null) { Object.assign(this, { collection, filters, order, limitValue: limit, id }) }
  where (field, op, value) { return new ReportQuery(this.collection, [...this.filters, { field, op, value }], this.order, this.limitValue, this.id) }
  orderBy (field, direction = 'asc') { return new ReportQuery(this.collection, this.filters, { field, direction }, this.limitValue, this.id) }
  limit (value) { return new ReportQuery(this.collection, this.filters, this.order, value, this.id) }
  doc (id) { return new ReportQuery(this.collection, this.filters, this.order, this.limitValue, id) }
  async get () {
    const result = await read({ kind: 'firestore', collection: this.collection, filters: this.filters, order: this.order, limit: this.limitValue, id: this.id })
    const docs = result.documents.map(doc => ({ id: doc.id, exists: true, data: () => doc.data }))
    if (this.id) return docs[0] || { id: this.id, exists: false, data: () => undefined }
    return { docs, size: docs.length, empty: !docs.length, forEach: callback => docs.forEach(callback) }
  }
  onSnapshot (callback, errorCallback) { let cancelled = false; this.get().then(value => { if (!cancelled) callback(value) }).catch(error => { if (errorCallback) errorCallback(error) }); return () => { cancelled = true } }
  set () { return denied() }
  update () { return denied() }
  delete () { return denied() }
  add () { return denied() }
}
function firestore () {
  return { collection: name => new ReportQuery(name.replace(/^\/+|\/+$/g, '')) }
}
Object.assign(firestore, firebase.firestore)
const saleData = Object.create(firebase)
Object.defineProperties(saleData, { database: { value: database }, firestore: { value: firestore } })
export default saleData
